// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".editor-plain .public-DraftStyleDefault-block{height:auto}.editor-plain .rdw-editor-toolbar{display:none}.editor-plain .DraftEditor-editorContainer,.editor-plain .title-message{border:none}", ""]);
// Exports
module.exports = exports;
